import superagent from 'superagent'

// A cold date can take the service 5-15 s to model, so callers that pass `patient` wait up to a minute and
// try once more.
const PATIENT = { timeout: { response: 45000, deadline: 60000 }, retries: 1 }

const get = (path, query, token, patient) => new Promise((resolve, reject) => {
  const req = superagent
    .get(`${__API_URI__}/Thermals/${path}`)
    .query(query)
  if (patient) req.timeout(PATIENT.timeout).retry(PATIENT.retries)
  req
    .set('Authorization', `Bearer ${token}`)
    .set('Platform', 'Web')
    .set('Version', `${__version__}`)
    .end((err, res) => {
      if (err) {
        return reject(err)
      }
      resolve(res.body)
    })
})

const thermals = {
  // The slope wind over a square around a point at an hour (grids of u, v in m/s, regime and shade), and the
  // scent plume from the point along the forecast wind plus the slope wind.
  fetchField: (props) => {
    const { lat, lng, time, radiusKm, cellM, token } = props
    const query = { latitude: lat, longitude: lng, radiusKm, cellM }
    if (time) query.time = time
    return get('Get', query, token)
  },

  // The same square through a local day at the point: the shared grid once, then a frame per hour (and per
  // half hour around sunrise and sunset) with its grids packed as base64 int16. See lib/thermals/day.
  // `slopeWind: false` leaves out u, v and regime (about half the payload) for callers that draw only the
  // combined wind and the plume.
  fetchDay: (props) => {
    const { lat, lng, date, radiusKm, cellM, token, slopeWind, patient } = props
    const query = { latitude: lat, longitude: lng, radiusKm, cellM }
    if (date) query.date = date
    if (slopeWind === false) query.slopeWind = false
    return get('Day', query, token, patient)
  }
}

export default thermals
